export { default as defaultTheme } from './default.theme'



// WEBPACK FOOTER //
// ./src/themes/default/index.js